module.exports = __webpack_public_path__ + "static/img/wearing_scene.0f7adf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wearing_scene.jpg
// module id = mR1L
// module chunks = 1